import { DocumentRadioCertificate } from 'front-office/constants/document-radio-certificate';
import { ClaimsFormVM } from 'front-office/view-models/claims/claims-form';
import { DateTime } from 'luxon';
import { RequestCertificateGeneric } from 'shell/models/request-generic';

export const transformRequestClaimsData = (values: ClaimsFormVM): RequestCertificateGeneric => {
  const hasGenerality =
    (values.generality &&
      (values.applicant?.fiscalCode || values.applicant?.name || values.applicant?.surname)) ||
    values.applicant;

  const generalitaRichiedente = hasGenerality
    ? {
        docRiconoscimento:
          values.generality?.dateReleaseDocument || values.generality?.numberDocument
            ? {
                dataRilascio: values.generality?.dateReleaseDocument?.toFormat('yyyy-MM-dd'),
                estDocRiconoscimento: values.generality?.numberDocument,
              }
            : undefined,
        generalita: hasGenerality
          ? {
              idSchedaSoggettoANPR: values.generality?.idSubjectAnpr || undefined,
              codiceFiscale: values.applicant?.fiscalCode
                ? {
                    codFiscale: values.applicant?.fiscalCode,
                  }
                : undefined,
              nome: values.applicant?.name,
              cognome: values.applicant?.surname,
              senzaNome: values.applicant?.withoutName ? '1' : undefined,
              senzaCognome: values.applicant?.withoutSurname ? '1' : undefined,
              sesso: values.applicant?.gender,
              dataNascita: values.generality?.birthDate?.toFormat('yyyy-MM-dd'),
              senzaGiorno:
                !values.generality?.birthChoiceDate?.includes('day') &&
                values.generality?.birthChoiceDate?.includes('month')
                  ? '1'
                  : undefined,
              senzaGiornoMese:
                !values.generality?.birthChoiceDate?.includes('day') &&
                !values.generality?.birthChoiceDate?.includes('month') &&
                values.generality?.birthDate
                  ? '1'
                  : undefined,
              luogoNascita:
                values.generality?.municipalityOfBirth || values.generality?.foreignStateBirth
                  ? {
                      comune:
                        !values.generality?.isForeign && values.generality?.municipalityOfBirth
                          ? {
                              nomeComune: values.generality?.municipalityOfBirth?.description,
                              siglaProvinciaIstat: values.generality?.municipalityOfBirth?.province,
                              descrizioneLocalita: values.generality?.locality,
                            }
                          : undefined,
                      localita:
                        values.generality?.isForeign && values.generality?.foreignStateBirth
                          ? {
                              codiceStato: values.generality?.foreignStateBirth?.id,
                              descrizioneStato: values.generality?.foreignStateBirth?.value,
                              provinciaContea: values.generality?.foreignStateBirth?.province,
                              descrizioneLocalita:
                                values.generality?.foreignMunicipality?.description,
                            }
                          : undefined,
                    }
                  : undefined,
            }
          : undefined,
      }
    : undefined;

  const generalitaIntestatarioSameAsApplicant = hasGenerality
    ? {
        generalita: hasGenerality
          ? {
              idSchedaSoggettoANPR: values.generality?.idSubjectAnpr || undefined,
              codiceFiscale: values.applicant?.fiscalCode
                ? {
                    codFiscale: values.applicant?.fiscalCode,
                  }
                : undefined,
              nome: values.applicant?.name,
              cognome: values.applicant?.surname,
              senzaNome: values.applicant?.withoutName ? '1' : undefined,
              senzaCognome: values.applicant?.withoutSurname ? '1' : undefined,
              sesso: values.applicant?.gender,
              dataNascita: values.generality?.birthDate?.toFormat('yyyy-MM-dd'),
              senzaGiorno:
                !values.generality?.birthChoiceDate?.includes('day') &&
                values.generality?.birthChoiceDate?.includes('month')
                  ? '1'
                  : undefined,
              senzaGiornoMese:
                !values.generality?.birthChoiceDate?.includes('day') &&
                !values.generality?.birthChoiceDate?.includes('month') &&
                values.generality?.birthDate
                  ? '1'
                  : undefined,
              luogoNascita:
                values.generality?.municipalityOfBirth || values.generality?.foreignStateBirth
                  ? {
                      comune:
                        !values.generality?.isForeign && values.generality?.municipalityOfBirth
                          ? {
                              nomeComune: values.generality?.municipalityOfBirth?.description,
                              siglaProvinciaIstat: values.generality?.municipalityOfBirth?.province,
                              descrizioneLocalita: values.generality?.locality,
                            }
                          : undefined,
                      localita:
                        values.generality?.isForeign && values.generality?.foreignStateBirth
                          ? {
                              codiceStato: values.generality?.foreignStateBirth?.id,
                              descrizioneStato: values.generality?.foreignStateBirth?.value,
                              provinciaContea: values.generality?.foreignStateBirth?.province,
                              descrizioneLocalita:
                                values.generality?.foreignMunicipality?.description,
                            }
                          : undefined,
                    }
                  : undefined,
            }
          : undefined,
      }
    : undefined;

  const generalitaIntestatario = values.accountholder
    ? {
        generalita: values.accountholder
          ? {
              idSchedaSoggettoANPR:
                values.accountholder?.account?.generality?.idSubjectAnpr || undefined,
              codiceFiscale: values.accountholder?.account?.applicant?.fiscalCode
                ? {
                    codFiscale: values.accountholder?.account?.applicant?.fiscalCode,
                  }
                : undefined,
              nome: values.accountholder?.account?.applicant?.name,
              cognome: values.accountholder?.account?.applicant?.surname,
              senzaNome: values.accountholder?.account?.applicant?.withoutName ? '1' : undefined,
              senzaCognome: values.accountholder?.account?.applicant?.withoutSurname
                ? '1'
                : undefined,
              sesso: values.accountholder?.account?.applicant?.gender || '',
              dataNascita:
                values.accountholder?.account?.generality?.birthDate?.toFormat('yyyy-MM-dd'),
              senzaGiorno:
                !values.accountholder?.account?.generality?.birthChoiceDate?.includes('day') &&
                values.accountholder?.account?.generality?.birthChoiceDate?.includes('month')
                  ? '1'
                  : undefined,
              senzaGiornoMese:
                values.accountholder?.account?.generality?.birthDate &&
                !values.accountholder?.account?.generality?.birthChoiceDate?.includes('day') &&
                !values.accountholder?.account?.generality?.birthChoiceDate?.includes('month')
                  ? '1'
                  : undefined,
              luogoNascita:
                values.accountholder?.account?.generality?.municipalityOfBirth ||
                values.accountholder?.account?.generality?.foreignStateBirth
                  ? {
                      comune:
                        !values.accountholder?.account?.generality?.isForeign &&
                        values.accountholder?.account?.generality?.municipalityOfBirth
                          ? {
                              nomeComune:
                                values.accountholder?.account?.generality?.municipalityOfBirth
                                  ?.description,
                              siglaProvinciaIstat:
                                values.accountholder?.account?.generality?.municipalityOfBirth
                                  ?.province,
                              descrizioneLocalita:
                                values.accountholder?.account?.generality?.locality,
                            }
                          : undefined,
                      localita:
                        values.accountholder?.account?.generality?.isForeign &&
                        values.accountholder?.account?.generality?.foreignStateBirth
                          ? {
                              codiceStato:
                                values.accountholder?.account?.generality?.foreignStateBirth?.id,
                              descrizioneStato:
                                values.accountholder?.account?.generality?.foreignStateBirth?.value,
                              provinciaContea:
                                values.accountholder?.account?.generality?.foreignStateBirth
                                  ?.province,
                              descrizioneLocalita:
                                values.accountholder?.account?.generality?.foreignMunicipality
                                  ?.description,
                            }
                          : undefined,
                    }
                  : undefined,
            }
          : undefined,
      }
    : undefined;

  const cdCertificato = values.claims ? `AT${values.claims.key.codiceDocumento}` : undefined;

  // residence address
  const toponym = values?.accountholder?.sameApplicant
    ? values.generality?.residence?.indirizzo?.toponimo
    : values.accountholder?.account?.generality?.residence?.indirizzo?.toponimo;
  // const toponym = values.generality?.residence?.indirizzo?.toponimo;

  const civic = values?.accountholder?.sameApplicant
    ? values.generality?.residence?.indirizzo?.numeroCivico
    : values?.accountholder?.account?.generality?.residence?.indirizzo?.numeroCivico;

  const indirizzoResidenzaIntestatario = `${
    toponym?.descrizionePostale ||
    `${toponym?.specie || ''} ${toponym?.denominazioneToponimo || ''}`
  }${civic?.numero ? `,${civic.numero}` : ''}${
    civic?.esponente1 ? `/${civic?.esponente1}${civic?.lettera || ''}` : ''
  }`;

  let cartaIdentitaComuneRilascio = '';

  if (values?.accountholder?.sameApplicant) {
    if (values?.generality?.isForeignDocument === DocumentRadioCertificate.Other) {
      cartaIdentitaComuneRilascio = values.generality?.consulateCode || '';
    } else if (values?.generality?.isForeignDocument === DocumentRadioCertificate.IdentityCard) {
      cartaIdentitaComuneRilascio =
        `Comune di ${values.generality?.municipalityDocument?.description}` || '';
    }
  } else {
    if (values.accountholder?.account?.generality?.consulateCode) {
      cartaIdentitaComuneRilascio = values.accountholder?.account?.generality?.consulateCode || '';
    } else {
      cartaIdentitaComuneRilascio =
        `Comune di ${values.accountholder?.account?.generality?.municipalityDocument?.description}` ||
        '';
    }
  }

  let documentoIdentita = '';

  let numeroCarta = '';

  if (values?.accountholder?.sameApplicant) {
    numeroCarta =
      values.generality?.isFromAnpr &&
      values.generality?.isForeignDocument === DocumentRadioCertificate.IdentityCard
        ? `Carta d'identità n.${values.generality?.numberDocument || ''}`
        : values.generality?.numberDocument || '';

    documentoIdentita = `${numeroCarta || ''}
      rilasciato il ${
        values.generality?.dateReleaseDocument
          ? values.generality?.dateReleaseDocument?.toFormat('dd/MM/yyyy')
          : ''
      } da ${cartaIdentitaComuneRilascio}`;
  } else {
    numeroCarta =
      values.accountholder?.account?.generality?.isFromAnpr &&
      values.accountholder?.account?.generality?.isForeignDocument ===
        DocumentRadioCertificate.IdentityCard
        ? `Carta d'identità n.${values?.accountholder?.account?.generality?.numberDocument || ''}`
        : values?.accountholder?.account?.generality?.numberDocument || '';

    documentoIdentita = `${numeroCarta || ''} rilasciato il ${
      values?.accountholder?.account?.generality?.dateReleaseDocument
        ? values?.accountholder?.account?.generality?.dateReleaseDocument?.toFormat('dd/MM/yyyy')
        : ''
    } da ${cartaIdentitaComuneRilascio}`;
  }

  let provinciaResidenzaIntestatario = '';

  if (values?.generality?.residence?.indirizzo) {
    if (values?.accountholder?.sameApplicant) {
      provinciaResidenzaIntestatario =
        values.generality?.residence?.indirizzo?.comune?.siglaProvinciaIstat || '';
    } else {
      provinciaResidenzaIntestatario =
        values.accountholder?.account?.generality?.residence?.indirizzo?.comune
          ?.siglaProvinciaIstat || '';
    }
  } else {
    if (values?.accountholder?.sameApplicant) {
      provinciaResidenzaIntestatario =
        values.generality?.residence?.localitaEstera?.indirizzoEstero?.localita?.provinciaContea ||
        '';
    } else {
      provinciaResidenzaIntestatario =
        values.accountholder?.account?.generality?.residence?.localitaEstera?.indirizzoEstero
          ?.localita?.provinciaContea || '';
    }
  }

  let comuneResidenzaIntestatario = '';

  if (values?.generality?.residence?.indirizzo) {
    if (values?.accountholder?.sameApplicant) {
      comuneResidenzaIntestatario =
        values.generality?.residence?.indirizzo?.comune?.nomeComune || '';
    } else {
      comuneResidenzaIntestatario =
        values.accountholder?.account?.generality?.residence?.indirizzo?.comune?.nomeComune || '';
    }
  } else {
    if (values?.accountholder?.sameApplicant) {
      comuneResidenzaIntestatario =
        values.generality?.residence?.localitaEstera?.indirizzoEstero?.localita?.descrizioneStato ||
        '';
    } else {
      comuneResidenzaIntestatario =
        values.accountholder?.account?.generality?.residence?.localitaEstera?.indirizzoEstero
          ?.localita?.descrizioneStato || '';
    }
  }

  let luogoNascitaIntestatario = '';
  if (values?.accountholder?.sameApplicant) {
    if (!values?.generality?.isForeign) {
      luogoNascitaIntestatario = values?.generality?.municipalityOfBirth?.description || '';
    } else {
      luogoNascitaIntestatario = values?.generality?.foreignMunicipality?.description || '';
    }
  } else {
    if (values?.accountholder?.account?.generality?.foreignMunicipality) {
      luogoNascitaIntestatario =
        values?.accountholder?.account?.generality?.foreignMunicipality?.description || '';
    } else {
      luogoNascitaIntestatario =
        values?.accountholder?.account?.generality?.municipalityOfBirth?.description || '';
    }
  }
  return {
    generalitaRichiedente,
    usoInterno: values?.certificateInternOnly,
    motivoRilascio: values.accountholder?.account?.applicant?.releaseReason || undefined,
    cdCertificato,
    cognomeIntestatario: values?.accountholder?.sameApplicant
      ? values.applicant?.surname
      : values?.accountholder?.account?.applicant?.surname,
    nomeIntestatario: values?.accountholder?.sameApplicant
      ? values.applicant?.name
      : values.accountholder?.account?.applicant?.name,
    dataNascitaIntestatario: values?.accountholder?.sameApplicant
      ? values.generality?.birthDate?.toFormat('dd/MM/yyyy')
      : values.accountholder?.account?.generality?.birthDate?.toFormat('dd/MM/yyyy'),
    luogoNascitaIntestatario: luogoNascitaIntestatario,
    cittadino: values?.accountholder?.sameApplicant
      ? values.applicant?.gender
      : values.accountholder?.account?.applicant?.gender,
    // comune residenza, provincia residenza, indirizzo residenza
    comuneResidenzaIntestatario,
    provinciaResidenzaIntestatario,
    indirizzoResidenzaIntestatario,
    documentoIdentita,
    dataResidenzaIntestatario: values?.accountholder?.sameApplicant
      ? values.generality?.dati3002?.datiIscrizione?.datiIscrizioneComune?.dataIscrizione
        ? DateTime.fromISO(
            values.generality?.dati3002?.datiIscrizione?.datiIscrizioneComune?.dataIscrizione
          ).toFormat('dd/MM/yyyy')
        : undefined
      : values.accountholder?.account?.generality?.dati3002?.datiIscrizione?.datiIscrizioneComune
          ?.dataIscrizione
      ? DateTime.fromISO(
          values.accountholder?.account?.generality?.dati3002?.datiIscrizione?.datiIscrizioneComune
            ?.dataIscrizione
        ).toFormat('dd/MM/yyyy')
      : undefined,
    dataRichiesta: values.dateForm?.toFormat('dd/MM/yyyy') || undefined,
    // cittadiniTitoloCertificato ????
    // idFamigliaConvivenzaANPR se uguali allora richiedente altrimenti intestatario
    idFamigliaConvivenzaANPR: values?.accountholder?.sameApplicant
      ? values.generality?.idFamilyAnpr
      : values.accountholder?.account?.generality?.idFamilyAnpr,
    cartaIdentitaNRIntestatario: numeroCarta,
    cartaIdentitaRilasciataIl: values?.accountholder?.sameApplicant
      ? values.generality?.dateReleaseDocument?.toFormat('dd/MM/yyyy')
      : values?.accountholder?.account?.generality?.dateReleaseDocument?.toFormat('dd/MM/yyyy'),
    cartaIdentitaComuneRilascio,
    familiareUE: values.citizenUE ? 'S' : 'N', // Da verificare
    generalitaIntestatario: values?.accountholder?.sameApplicant
      ? generalitaIntestatarioSameAsApplicant?.generalita
      : generalitaIntestatario?.generalita,
    tipoPagamento: values.typePayment,
    tipoDocumento: values.claims,
    codiceStato: values?.accountholder?.sameApplicant
      ? values.generality?.idState
      : values?.accountholder?.account?.generality?.idState,
    // tipo indirizzo
    tipoIndirizzo: values?.accountholder?.sameApplicant
      ? values.generality?.residence?.tipoIndirizzo
      : values?.accountholder?.account?.generality?.residence?.tipoIndirizzo,
    figlio: [],
    // modalita rilascio
    codiceModalitaRilascio: values.modality?.id as string,
  };
};
